import React, { useState, useEffect } from 'react'
import './AddDepartment.css';
import { Alert, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { ADD_DEPARTMENT_FAIL, ADD_DEPARTMENT_START, ADD_DEPARTMENT_SUCCESS, UPDATE_DEPARTMENT_START, UPDATE_DEPARTMENT_SUCCESS } from '../../../RTK/Slices/DepartmentSlice';
import { addDepartment, editDepartment, get_departmentDetail, get_departments, getDepartmentDistricts } from '../../../helper/Api';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { validateUploadDocument } from '../../../helper/uploadValidation';
import CustomBreadcrumbs from '../../Tools/Breadcumbs';
import Spinner from '../../Tools/spinner';
import { DepartmentDistrictBadge } from '../../Tools/DepartmentIdentityCell';
import { openSecureDocumentOrToast } from '../../../helper/secureDocuments';
const AddDepartmentForm = () => {
    const { id } = useParams();
    const { authData } = useSelector((state) => state.authData);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        code: null,
        name: null,
        nomiclature: null,
        district_id: '',
        department_level: authData.user.department_details.department_level == 'T1' ? 'T2' : authData.user.department_details.department_level == 'T2' ? 'T3' : 'T4',
        department_type: "",
        parent_department_id_t2: authData.user.department_details.department_level == 'T2' ? authData.user.department_id : null ,
        parent_department_id_t3: authData.user.department_details.department_level == 'T3' ? authData.user.department_id : null,
        parent_department_id: authData.user.department_id,
        attachments: [],
    });
    const [districts, setDistricts] = useState([]);
    const [departmentT2, setDepartmentT2] = useState([]);
    const [departmentT3, setDepartmentT3] = useState([]);
    const [t1Details, sett1Details] = useState({});
    const [t2Details, sett2Details] = useState({});
    const [t3Details, sett3Details] = useState({});
    const [error, setError] = useState({
        status: false,
        msg: ''
    });
    useEffect(() => {
        if (id) {
            setFormDetails(id);
        }
        fetctDetails(authData.user.department_id);
        setDefaultPageData();
        loadDistricts();
    }, [id]);

    const loadDistricts = async () => {
        try {
            const resp = await getDepartmentDistricts();
            const list = resp?.data?.result || resp?.data?.list || [];
            setDistricts(Array.isArray(list) ? list : []);
        } catch (_error) {
            setDistricts([]);
            toast.error('Failed to load districts', {
                position: toast.POSITION.TOP_CENTER,
            });
        }
    };

    const setDefaultPageData = async () => {
        setLoading(true);
        if(authData.user?.department_details?.department_level === 'T2') {
            await fetctDetails(authData.user.department_details.parent_department_id);
            await levelDetails('T2');
        }
        setLoading(false);
    }

    const handleFormDataChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        if(name === 'department_level') {
            setFormData({ ...formData, [name]: value, parent_department_id_t2: null, parent_department_id_t3: null })
        }else{
            setFormData({ ...formData, [name]: value })
        }
        if (name === 'department_level') {
            if (value == 'T3') {
                sett2Details({})
                levelDetails('T2');
            }
            if (value == 'T4') {
                sett2Details({})
                sett3Details({})
                for (let item of ["T1", "T2", "T3"]) {
                    levelDetails(item);
                }
                
            }
        }
    }
    const handleDepartment = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setFormData({ ...formData, [name]: value })
        fetctDetails(value);
        if(name === 'parent_department_id_t2' && (formData.department_level === 'T4')) {
            sett3Details({})
            levelDetails('T3', value);
        }
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            toast.error('Please fill in all required fields, including District.', {
                position: toast.POSITION.TOP_CENTER,
            });
            return;
        }
        setLoading(true);
        try {
            dispatch(ADD_DEPARTMENT_START());
            const post_data = new FormData();
            for (let i = 0; i < formData.attachments.length; i++) {
                post_data.append('attachment[]', formData.attachments[i]);
            }
            if(formData.department_level === 'T3') {
                formData.parent_department_id = formData.parent_department_id_t2
            }
            if(formData.department_level === 'T4') {
                formData.parent_department_id = formData.parent_department_id_t3
            }
            post_data.append('code', formData.code);
            post_data.append('name', formData.name);
            post_data.append('nomiclature', formData.nomiclature);
            post_data.append('district_id', formData.district_id);
            post_data.append('department_level', formData.department_level);
            post_data.append('parent_department_id', formData.parent_department_id);
            post_data.append('department_type', formData.department_type);
            if (id) {
                dispatch(UPDATE_DEPARTMENT_START());
                const add_department_response = await editDepartment(post_data, id);
                if (add_department_response?.data?.status || add_department_response?.status) {
                    const payload = add_department_response?.data || add_department_response;
                    dispatch(UPDATE_DEPARTMENT_SUCCESS(payload));
                    toast.success(payload.message || 'Department updated', {
                        position: toast.POSITION.TOP_CENTER
                    });
                    setLoading(false);
                    navigate('/addchildAccount');
                } else {
                    const errMsg =
                        add_department_response?.data?.error ||
                        add_department_response?.data?.message ||
                        add_department_response?.message ||
                        'Failed to update department';
                    toast.error(errMsg, {
                        position: toast.POSITION.TOP_CENTER
                    });
                    dispatch(ADD_DEPARTMENT_FAIL(errMsg));
                }
            }
            else {
                dispatch(ADD_DEPARTMENT_START());
                const add_department_response = await addDepartment(post_data);
                if (add_department_response?.data?.status || add_department_response?.status) {
                    const payload = add_department_response?.data || add_department_response;
                    dispatch(ADD_DEPARTMENT_SUCCESS(payload));
                    toast.success(payload.message || 'Department created', {
                        position: toast.POSITION.TOP_CENTER
                    });
                    setLoading(false);
                    navigate('/addchildAccount');
                } else {
                    const errMsg =
                        add_department_response?.data?.error ||
                        add_department_response?.data?.message ||
                        add_department_response?.message ||
                        'Failed to create department';
                    toast.error(errMsg, {
                        position: toast.POSITION.TOP_CENTER
                    });
                    dispatch(ADD_DEPARTMENT_FAIL(errMsg));
                }
            }
        } catch (error) {
            const errMsg =
                error?.response?.data?.error ||
                error?.response?.data?.message ||
                error?.message ||
                'error getting while add department';
            toast.error(errMsg, {
                position: toast.POSITION.TOP_CENTER
            });
            dispatch(ADD_DEPARTMENT_FAIL(errMsg));
        } finally {
            setLoading(false);
        }
    }
    const validateForm = () => {
        // Validate each field individually
        if (!String(formData.code || '').trim() ||
            !String(formData.name || '').trim() ||
            !String(formData.nomiclature || '').trim() ||
            !formData.district_id) {
            return false; // If any field is empty, return false
        }
        return true; // All fields are valid
    };
    const handleAttachmentChange = (event) => {
        if (validateFile(event.target)) {
            const files = Array.from(event.target.files);
            console.log('ddddd', files)
            setFormData({
                ...formData,
                attachments: files
            });
        }
    };
    function validateFile(input) {
        const file = input.files[0];
        if (!file) {
            return false;
        }
        const validation = validateUploadDocument(file);
        if (!validation.ok) {
            toast.error(validation.message, {
                position: toast.POSITION.TOP_CENTER
            });
            input.value = '';
            return false;
        }
        return true;
    }
    const fetctDetails = async (id) => {
        try {
            const departmentDetail = await get_departmentDetail({ id: id });
            const departObject = departmentDetail.data.result[0];
            if (departmentDetail.data.status) {
                if (departObject.department_level == 'T1') {
                    sett1Details(departObject);
                }
                if (departObject.department_level == 'T2') {
                    console.log(' m in t2');
                    sett2Details(departObject);
                }
                if (departObject.department_level == 'T3') {
                    sett3Details(departObject);
                }
                setFormData(prevState => ({
                    ...prevState,
                    parent_department_id: departObject.id || authData.user.department_id,
                }));
            }
        } catch (error) {
            console.log("departments");
        }
    }
    const setFormDetails = async (id) => {
        try {
            const departmentDetail = await get_departmentDetail({ id: id });
            const departObject = departmentDetail.data.result[0];
            if (departmentDetail.data.status) {
                setFormData(prevState => ({
                    ...prevState,
                    code: departObject.code,
                    name: departObject.name,
                    nomiclature: departObject.nomiclature,
                    district_id:
                        departObject.district_id != null && departObject.district_id !== ''
                            ? String(departObject.district_id)
                            : '',
                    department_level: departObject.department_level,
                    department_type: departObject.department_type,
                    parent_department_id: departObject.parent_department_id || authData.user.department_id,
                    parent_department_id_t2: departObject.department_level === 'T3' ? departObject.parent_department_id : null,
                    parent_department_id_t3: departObject.department_level === 'T4' ? departObject.parent_department_id : null,
                    // attachment: prevState.attachment.concat(
                    //     departObject.letter_url ? [{ letter_url: departObject.letter_url }] : []
                    // ),
                }));

                if(departObject.department_level === 'T3' || departObject.department_level === 'T4') {
                    levelDetails('T2');
                    if(departObject.department_level === 'T4') {
                        const departmentDetail = await get_departmentDetail({ id: departObject.parent_department_id });
                        await fetctDetails(departmentDetail?.data?.result[0].parent_department_id);
                        setFormData(prevState => ({
                            ...prevState,
                            parent_department_id_t2: departmentDetail?.data?.result[0].parent_department_id
                        }))
                        // formData.parent_department_id_t2 = departmentDetail?.data?.result[0].parent_department_id;
                    }else{
                        await fetctDetails(departObject.parent_department_id);
                    }
                    
                }
                if(departObject.department_level === 'T4') {
                    const departmentDetail = await get_departmentDetail({ id: departObject.parent_department_id });
                    levelDetails('T3', departmentDetail?.data?.result[0].parent_department_id);
                    await fetctDetails(departObject.parent_department_id);
                }

                
            }
        } catch (error) {
            console.log("departments", error);
        }
    }
    const levelDetails = async (value, parent_department_id = null) => {
        try {
            const departments = await get_departments({ department_level: value, parent_department_id });
            if (departments.data.status) {
                if(value === 'T2' && authData.user.department_details.department_level === 'T2') {
                    setDepartmentT2(departments.data.result.filter(d => d.id === authData.user.department_id));
                    fetctDetails(authData.user.department_id);
                }else if(value === 'T2') {
                    departments.data.result.unshift({id: null, name: '-- Select T2 Department --'});
                    setDepartmentT2(departments.data.result);
                }
                else if(value === 'T3' && (parent_department_id || authData.user?.department_details?.department_level === 'T2')) {
                    departments.data.result.unshift({id: null, name: '-- Select T3 Department --'});
                    parent_department_id = parent_department_id ? parent_department_id : authData.user.department_id;
                    setDepartmentT3(departments.data.result.filter(d => d.id === null || d.parent_department_id === parent_department_id));
                } else if(value === 'T3') {
                    // departments.data.result.unshift({id: null, name: '-- Select T3 Department --'});
                    setDepartmentT3([{id: null, name: '-- Select T3 Department --'}]);
                }
                else {
                    fetctDetails(departments.data.result[0].id);
                }
                // setDepartment(departments.data.result);
                // fetctDetails(departments.data.result[0].id);
            }
        } catch (error) {
            console.log("get_departments error");
        }
    }
    const linksArray = [
        {
        href: "/departments",
        label: "Departments",
        }
    ]
    return (
        <div>
            {loading && <div > <Spinner/> </div>}
            <div className="p-3">
                <div className="row">
                    {error.status && (
                        <Alert variant="danger" onClose={() => setError({ status: false, msg: '' })} dismissible>
                            {error.msg}
                        </Alert>
                    )}
                    <Form onSubmit={handleSubmit}>
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-6">
                                    <h4 style={{ color: "#28326f", margin: 0 }}>Add Department</h4>
                                    <CustomBreadcrumbs linksArray={linksArray} title="Add Department" />
                                </div>
                                <div className="col-md-6">
                                    <div
                                    className="d-flex gap-2"
                                    style={{ width: "auto", float: "right" }}
                                    >
                                    <button type="submit" disabled={loading} className="submit_button">
                                        {loading ? 'loading' : id ? 'Update' : 'Submit'}</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card p-3 mt-3">
                                <div className="row">
                                    <div className="col-md-12 ">
                                    <div className="form-group row p-2">
                                            <label className="col-sm-4 col-form-label">Department Type</label>
                                            <div className="col-sm-8">
                                                <select className="form-control"
                                                    name="department_level"
                                                    value={formData.department_level}
                                                    onChange={handleFormDataChange}
                                                    required>
                                                    {(authData.user.department_details.department_level === 'T1') && <option value="T2">T2</option>}
                                                    {(authData.user.department_details.department_level === 'T1' || authData.user.department_details.department_level === 'T2') && <option value="T3">T3</option>}
                                                    {(authData.user.department_details.department_level === 'T1' || authData.user.department_details.department_level === 'T2' || authData.user.department_details.department_level === 'T3') && <option value="T4">T4</option>}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="table-responsive mt-4">
                                            <h6 class="department_level">T1 Department Details</h6>
                                            <table className="table table-bordered table-center">
                                                <thead>
                                                    <tr>
                                                        <th>Code</th>
                                                        <th>Name</th>
                                                        <th>Level (District/Block/PIU)</th>
                                                        <th>District</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>{t1Details.code}</td>
                                                        <td>{t1Details.name}</td>
                                                        <td>{t1Details.nomiclature}</td>
                                                        <td>
                                                            {t1Details.district_name ? (
                                                                <DepartmentDistrictBadge row={t1Details} />
                                                            ) : (
                                                                '-'
                                                            )}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        {(formData.department_level === 'T3' || formData.department_level === 'T4') &&
                                            <div className="form-group row p-2">
                                                <label className="col-sm-4 col-form-label">Department T2</label>
                                                <div className="col-sm-8">
                                                    <select className="form-control"
                                                        name="parent_department_id_t2"
                                                        onChange={handleDepartment}
                                                        // value={formData.parent_department_id}
                                                        required>
                                                        {departmentT2.map(option => (
                                                            <option key={option.name} value={option.id}
                                                            selected={formData.parent_department_id_t2 === option.id ? true: false}
                                                            >
                                                                {option.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        }
                                        {(formData.department_level === 'T3' || formData.department_level === 'T4') &&
                                        <div className="table-responsive mt-4">   
                                            <h6 class="department_level">T2 Department Details</h6>
                                            <table className="table table-bordered table-center">
                                                <thead>
                                                    <tr>
                                                        <th>Code</th>
                                                        <th>Name</th>
                                                        <th>Level (District/Block/PIU)</th>
                                                        <th>District</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>{t2Details.code}</td>
                                                        <td>{t2Details.name}</td>
                                                        <td>{t2Details.nomiclature}</td>
                                                        <td>
                                                            {t2Details.district_name ? (
                                                                <DepartmentDistrictBadge row={t2Details} />
                                                            ) : (
                                                                '-'
                                                            )}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        }
                                        {(formData.department_level === 'T4') &&
                                            <div className="form-group row p-2">
                                                <label className="col-sm-4 col-form-label">Department T3</label>
                                                <div className="col-sm-8">
                                                    <select className="form-control"
                                                        name="parent_department_id_t3"
                                                        onChange={handleDepartment}
                                                        value={formData.parent_department_id_t3}
                                                        required>
                                                        {departmentT3.map(option => (
                                                            <option key={option.name} value={option.id}>
                                                                {option.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            }
                                        {(formData.department_level === 'T4') && <><h6 class="department_level">T3 Department Details</h6>
                                            <table className="table table-bordered table-center">
                                                <thead>
                                                    <tr>
                                                        <th>Code</th>
                                                        <th>Name</th>
                                                        <th>Level (District/Block/PIU)</th>
                                                        <th>District</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>{t3Details.code}</td>
                                                        <td>{t3Details.name}</td>
                                                        <td>{t3Details.nomiclature}</td>
                                                        <td>
                                                            {t3Details.district_name ? (
                                                                <DepartmentDistrictBadge row={t3Details} />
                                                            ) : (
                                                                '-'
                                                            )}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </>
                                        }
                                        
                                        <div className="form-group row p-2">
                                            <label for="inputEmployee" className="col-sm-4 col-form-label">
                                                {formData.department_level} Code<span className="text-danger">*</span> :</label>
                                            <div className="col-sm-8">
                                                <input type="text" className="form-control" id="inputEmployee"
                                                    name="code"
                                                    value={formData.code}
                                                    onChange={handleFormDataChange}
                                                    required
                                                    maxLength={10}
                                                    placeholder="Enter Code" />
                                            </div>
                                        </div>
                                        <div className="form-group row p-2">
                                            <label for="inputUserid" className="col-sm-4 col-form-label">{formData.department_level} Name<span
                                                className="text-danger">*</span> :</label>
                                            <div className="col-sm-8">
                                                <input type="text" className="form-control"
                                                    id="inputUserid"
                                                    name="name"
                                                    required
                                                    maxLength={30}
                                                    value={formData.name}
                                                    onChange={handleFormDataChange}
                                                    placeholder="Enter Name" />
                                            </div>
                                        </div>
                                        <div className="form-group row p-2">
                                            <label for="inputEmployee" className="col-sm-4 col-form-label">
                                                {formData.department_level} Level (District/Block/PIU)<span className="text-danger">*</span> :</label>
                                            <div className="col-sm-8">
                                                <input type="text" className="form-control" id="inputEmployee"
                                                    name="nomiclature"
                                                    value={formData.nomiclature}
                                                    onChange={handleFormDataChange}
                                                    required
                                                    maxLength={10}
                                                    placeholder="Enter Level (District/Block/PIU)" />
                                            </div>
                                        </div>
                                        <div className="form-group row p-2">
                                            <label className="col-sm-4 col-form-label" htmlFor="district_id">
                                                District<span className="text-danger">*</span> :
                                            </label>
                                            <div className="col-sm-8">
                                                <select
                                                    className="form-control"
                                                    id="district_id"
                                                    name="district_id"
                                                    value={formData.district_id}
                                                    onChange={handleFormDataChange}
                                                    required
                                                >
                                                    <option value="">--- Select District ---</option>
                                                    {districts.map((item) => (
                                                        <option key={item.id} value={String(item.id)}>
                                                            {item.district}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-group row p-2">
                                            <label for="inputDesignation"
                                                className="col-sm-4 col-form-label">Letter of Department<span
                                                    className="text-danger">*</span> :</label>
                                            <div className="col-sm-8">
                                                <label className='p-1'>
                                                    <input id="" type="file"
                                                        className='form-control'
                                                        onChange={handleAttachmentChange}
                                                        name='attachment'
                                                        accept=".pdf,.jpeg,.jpg,.png"
                                                        multiple />
                                                </label>
                                                {
                                                    (id && formData.letter_url) ? (
                                                        <button
                                                            type="button"
                                                            className="btn btn-link p-0"
                                                            onClick={() => openSecureDocumentOrToast(formData.letter_url)}
                                                        >
                                                            Link: Letter Attachement
                                                        </button>
                                                    ) : ''
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    )
}

export default AddDepartmentForm
